export default __webpack_public_path__ + "static/media/ logo.d879abc5.png";